<!-- #region Error Handling -->
@if (false) {

}
<!-- #endregion -->